$(function(){
    if(window.location.pathname == "/collections/color-green"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/petite-bridesmaid-dresses/color-dark-purple"){
      window.location.href="/collections/petite-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/midi-dresses/color-purple-orchid+Floor-Length"){
      window.location.href="/collections/midi-dresses";
    }else if(window.location.pathname == "/collections/dresses/color-white+V-Neck"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/maternity-bridesmaid-dresses/color-purple-orchid"){
      window.location.href="/collections/maternity-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/navy-blue-dresses/color-navy-blue+Floor-Length"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/blush-bridesmaid-dresses/color-pink"){
      window.location.href="/collections/pink-bridesmaid-dresses?filter.v.option.color=Pink";
    }else if(window.location.pathname == "/collections/mother-of-the-bride-groom-dresses/color-dusty-blue"){
      window.location.href="/collections/bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/all/Floor-Length"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/new-arrivals/color-dark-purple+over-80"){
      window.location.href="/collections/new-arrivals";
    }else if(window.location.pathname == "/collections/plus-size-dresses/color-burgundy+Short"){
      window.location.href="/collections/plus-size-dresses";
    }else if(window.location.pathname == "/collections/the-wedding-shop/color-dusty-blue"){
      window.location.href="/collections/the-wedding-shop";
    }else if(window.location.pathname == "/collections/bridesmaid-dresses/color-navy-blue+V-Neck"){
      window.location.href="/collections/bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/new-bridesmaid-dresses/color-sky-blue"){
      window.location.href="/collections/new-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/green-bridesmaid-dresses/color-burnt-orange"){
      window.location.href="/collections/bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/dresses/Square-Neckline"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/evening-dresses-gowns/color-black+30-40"){
      window.location.href="/collections/evening-dresses-gowns";
    }else if(window.location.pathname == "/collections/semi-annual-sale/Sweetheart-Neckline"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/long-bridesmaid-dresses/color-gold"){
      window.location.href="/collections/long-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/homecoming-dresses/color-black"){
      window.location.href="/collections/homecoming-dresses";
    }else if(window.location.pathname == "/collections/evening-dresses-gowns/70-80"){
      window.location.href="/collections/evening-dresses-gowns";
    }else if(window.location.pathname == "/collections/green-bridesmaid-dresses/color-grey"){
      window.location.href="/collections/bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/maternity-bridesmaid-dresses/color-sky-blue"){
      window.location.href="/collections/maternity-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/evening-dresses-gowns/Floor-Length+Off-Shoulder"){
      window.location.href="/collections/evening-dresses-gowns";
    }else if(window.location.pathname == "/collections/bridesmaid-dresses/color-black+Floor-Length"){
      window.location.href="/collections/bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/lace-wedding-dresses/Floor-Length"){
      window.location.href="/collections/lace-wedding-dresses";
    }else if(window.location.pathname == "/collections/dresses/color-red+Floor-Length"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/dresses/color-red+Floor-Length"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/wedding-dresses/60-70"){
      window.location.href="/collections/wedding-dresses";
    }else if(window.location.pathname == "/collections/dresses/color-green"){
      window.location.href="/collections/dresses";
    }else if(window.location.pathname == "/collections/new-arrivals/color-pink"){
      window.location.href="/collections/new-arrivals";
    }else if(window.location.pathname == "/collections/burnt-orange-bridesmaid-dresses/color-burnt-orange"){
      window.location.href="/collections/burnt-orange-bridesmaid-dresses?filter.v.option.color=Burnt+Orange";
    }else if(window.location.pathname == "/collections/sage-green-dresses/color-green-bean"){
      window.location.href="/collections/sage-green-dresses";
    }else if(window.location.pathname == "/collections/purple-orchid-bridesmaid-dresses/color-purple-orchid"){
      window.location.href="/collections/purple-orchid-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/navy-blue-bridesmaid-dresses/color-navy-blue"){
      window.location.href="/collections/navy-blue-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/green-wedding-guest-dress/color-dark-green"){
      window.location.href="/collections/green-wedding-guest-dress";
    }else if(window.location.pathname == "/collections/bridesmaid-dresses/graduation-dresses"){
      window.location.href="/collections/bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/bridesmaid-dresses/sequin%20dresses"){
      window.location.href="/collections/bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/bridesmaid-dresses/evening-dresses-gowns"){
      window.location.href="/collections/bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/fall-bridesmaid-dresses"){
      window.location.href="/collections/autumn-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/wedding-guest-dresses-under-50"){
      window.location.href="/collections/affordable-wedding-guest-dresses";
    }else if(window.location.pathname == "/collections/cheap-prom-dresses"){
      window.location.href="/collections/prom-dresses-under-50";
    }else if(window.location.pathname == "/collections/lace-evening-dresses-1"){
      window.location.href="/collections/lace-evening-dresses";
    }else if(window.location.pathname == "/collections/blush-bridesmaid-dresses"){
      window.location.href="/collections/blush-pink-bridesmaid-dresses";
    }else if(window.location.pathname == "/collections/evening-dresses-with-sleeve"){
      window.location.href="/collections/evening-gowns-with-sleeves";
    }else if(window.location.pathname == "/products/elegant-sleeveless-v-neck-semi-formal-maxi-dress-ep09016-3"){
      window.location.href="/products/sleeveless-v-neck-semi-formal-maxi-dress-ep09016-1";
    }else if(window.location.pathname == "/collections/cyber-monday-crazy-deals"){
      window.location.href="/collections/crazy-saturday";
    }else if(window.location.pathname == "/blogs/ever-pretty-fashion-style-guides/destination-wedding-dreams-finding-the-perfect-dress-for-your-beach-wedding"){
      window.location.href="/blogs/ever-pretty-fashion-style-guides/perfect-beach-wedding-dress-styles";
    }
  })